import { axiosInstanceWeb, axiosInstanceWebV2 } from './web.axios.instance';
import axiosInstance from './axios.instance';
export const GET_DATA_FROM_API_FOR_CASA_WEB = async (metadataLink) => {
  return await axiosInstanceWeb.get(metadataLink).catch((err) => err);
};

export const API_GET_WEB_WIDGET_TEMPLATE = async () => {
  return await axiosInstanceWeb.get(`/widget-templates`).catch((err) => err.response);
};

export const API_ADD_WEB_HOMEPAGE = async () => {
  return await axiosInstanceWeb.post('/dashboards').catch((err) => err.response);
};

export const API_UPDATE_WEB_HOMEPAGE = async (dashboardIdParam, postBody) => {
  return await axiosInstanceWeb
    .put(`/dashboards/${dashboardIdParam}`, postBody)
    .catch((err) => err.response);
};

export const API_EDIT_WEB_HOMEPAGE = async (id, postBody) => {
  return await axiosInstanceWeb.put(`/dashboards/${id}`, postBody).catch((err) => err.response);
};

export const API_GET_WEB_DASHBOARD = (dashboardId) =>
  axiosInstanceWeb.get(`/dashboards/${dashboardId}`);

export const API_POST_CLONE_WEB_HOMEPAGE = async (id, params = {}) => {
  return await axiosInstanceWeb
    .post(`/dashboards/${id}/clone`, {}, { params })
    .catch((err) => err.response);
};

export const API_UPDATE_WEB_TEAM_DASHBOARDS = async (teamId, postBody) => {
  return await axiosInstanceWeb
    .put(`/dashboard-teams/${teamId}/order`, postBody)
    .catch((err) => err.response);
};

export const API_GET_ALL_WEB_DASHBOARDS = async () => {
  return await axiosInstanceWeb.get(`/dashboards`).catch((err) => err.response);
};

export const API_GET_WEB_TEAMS_DASHBOARDS = async () => {
  return await axiosInstanceWeb.get(`/dashboard-teams`).catch((err) => err.response);
};

export const API_GET_WEB_TEAMS_DASHBOARDS_V2 = async () => {
  return await axiosInstanceWebV2.get(`/dashboard-teams`).catch((err) => err.response);
};

export const API_DELETE_WEB_TEAM = async (teamId) => {
  return await axiosInstanceWeb.delete(`/teams/${teamId}`).catch((err) => err.response);
};

export const API_DELETE_WEB_DASHBOARD = async (dashboardId) => {
  return await axiosInstanceWeb.delete(`/dashboards/${dashboardId}`).catch((err) => err.response);
};

export const API_DELETE_CLONE_WEB_DASHBOARD = async (dashboardId) => {
  return await axiosInstanceWeb
    .delete(`/dashboards/${dashboardId}/draft`)
    .catch((err) => err.response);
};

export const API_BULK_DELETE_WEB_DASHBOARDS = async (dashboardIds) => {
  return await axiosInstanceWeb
    .delete(`/dashboards`, { data: { dashboardIds } })
    .catch((err) => err.response);
};

export const API_ADD_WEB_WIDGET = async (dashboardId, postBody) => {
  return await axiosInstanceWeb
    .post(`/dashboards/${dashboardId}/widgets`, postBody)
    .catch((err) => err.response);
};

export const API_UPDATE_WEB_WIDGET = async (widgetId, postBody, dashboardId) => {
  return await axiosInstanceWeb
    .put(`/widgets/${widgetId}?dashboardId=${dashboardId}`, { config: postBody })
    .catch((err) => err.response);
};

export const API_DELETE_WEB_WIDGET = async (dashboardId, widgetId) => {
  return await axiosInstanceWeb
    .delete(`/widgets/${widgetId}?dashboardId=${dashboardId}`)
    .catch((err) => err.response);
};

export const API_PUBLISH_WEB_DASHBOARD = async (dashboardId, postBody) => {
  return await axiosInstanceWeb
    .post(`/dashboards/${dashboardId}/publish`, postBody)
    .catch((err) => err.response);
};

export const API_CREATE_SIERA_WEB_HOMEPAGE = async (postBody) => {
  return await axiosInstanceWeb.post(`/dashboards/custom`, postBody).catch((err) => err.response);
};

export const API_PUBLISH_CLONE_WEB_DASHBOARD = async (dashboardId, postBody) => {
  return await axiosInstanceWeb
    .post(`/dashboards/${dashboardId}/republish`, postBody)
    .catch((err) => err.response);
};

export const API_UNPUBLISH_WEB_DASHBOARD = async (dashboardId) => {
  return await axiosInstanceWeb
    .post(`/dashboards/${dashboardId}/unpublish`)
    .catch((err) => err.response);
};

export const API_UPDATE_DASHBOARD_TEAM_ASSIGNMENT = async (dashboardId, postBody) => {
  return await axiosInstanceWeb
    .put(`/dashboards/${dashboardId}/teams`, postBody)
    .catch((err) => err.response);
};

export const API_GET_WEB_HOMEPAGE_SIGNED_URL = async (key) => {
  return await axiosInstance.get(`/widget/signedUrl/${key}`);
};

export const API_GET_WEB_HOMEPAGE_TASK_COUNT = async (postBody) => {
  return await axiosInstanceWeb.post(`/tasks/count`, postBody).catch((err) => err.response);
};
export const API_GET_WEB_UPLOAD_URL = async (featureName) => {
  const url = '/widgets/uploadUrl?' + `featureName=${featureName}`;
  return await axiosInstanceWeb.get(url);
};

export const API_GET_WEB_DASHBOARD_THUMBNAIL_UPLOAD_URL = async (dashboardId, orgCode) => {
  const key = `${orgCode}/casa/thumbnail/${dashboardId}`;
  return await axiosInstanceWeb.get(`/widgets/uploadUrl?key=${key}&featureName=THUMBNAIL`);
};
